import { render, staticRenderFns } from "./Volunteering.vue?vue&type=template&id=5f52864e&scoped=true&"
import script from "./Volunteering.vue?vue&type=script&lang=ts&"
export * from "./Volunteering.vue?vue&type=script&lang=ts&"
import style0 from "./Volunteering.vue?vue&type=style&index=0&id=5f52864e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52864e",
  null
  
)

export default component.exports